/**
 * Ordenação client-side para sliders/vitrines da PDP.
 * "best-selling" preserva a ordem original (API / collection).
 */
(function (global) {
  'use strict';

  function toNumber(value) {
    var n = Number(value);
    return isNaN(n) ? 0 : n;
  }

  function toTime(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return value;
    var asNum = Number(value);
    if (!isNaN(asNum) && String(value).trim() !== '') return asNum;
    var parsed = Date.parse(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  function compareTitle(a, b) {
    return String(a || '').localeCompare(String(b || ''), 'pt-BR', { sensitivity: 'base' });
  }

  /**
   * Ordena array de produtos (JSON da Recommendations API ou objetos normalizados).
   * Cada item deve ter: title, price, created_at|published_at, e _index (ordem original).
   */
  function sortProducts(products, mode) {
    var list = (products || []).slice();
    switch (mode) {
      case 'price-ascending':
        list.sort(function (a, b) { return toNumber(a.price) - toNumber(b.price); });
        break;
      case 'price-descending':
        list.sort(function (a, b) { return toNumber(b.price) - toNumber(a.price); });
        break;
      case 'created-descending':
        list.sort(function (a, b) {
          return toTime(b.published_at || b.created_at) - toTime(a.published_at || a.created_at);
        });
        break;
      case 'title-ascending':
        list.sort(function (a, b) { return compareTitle(a.title, b.title); });
        break;
      case 'title-descending':
        list.sort(function (a, b) { return compareTitle(b.title, a.title); });
        break;
      case 'best-selling':
      default:
        list.sort(function (a, b) { return toNumber(a._index) - toNumber(b._index); });
        break;
    }
    return list;
  }

  /**
   * Reordena filhos no DOM com data-price, data-title, data-created, data-index.
   */
  function sortElements(container, mode, itemSelector) {
    if (!container) return;
    var selector = itemSelector || '[data-pdp-sort-item]';
    var items = Array.prototype.slice.call(container.querySelectorAll(selector));
    items.sort(function (a, b) {
      switch (mode) {
        case 'price-ascending':
          return toNumber(a.getAttribute('data-price')) - toNumber(b.getAttribute('data-price'));
        case 'price-descending':
          return toNumber(b.getAttribute('data-price')) - toNumber(a.getAttribute('data-price'));
        case 'created-descending':
          return toNumber(b.getAttribute('data-created')) - toNumber(a.getAttribute('data-created'));
        case 'title-ascending':
          return compareTitle(a.getAttribute('data-title'), b.getAttribute('data-title'));
        case 'title-descending':
          return compareTitle(b.getAttribute('data-title'), a.getAttribute('data-title'));
        case 'best-selling':
        default:
          return toNumber(a.getAttribute('data-index')) - toNumber(b.getAttribute('data-index'));
      }
    });
    items.forEach(function (el) { container.appendChild(el); });
  }

  global.SymaPdpSort = {
    sortProducts: sortProducts,
    sortElements: sortElements
  };
})(typeof window !== 'undefined' ? window : this);
